/**
 * COMPLY-1 C3 — the "Privacy · Terms · Student Data Safeguards" link strip.
 * Shown on public surfaces (login, parent registration, olympiad signup, verify-email) and at the
 * foot of each legal page. Defaults to opening in a new tab so a half-filled signup form is never lost.
 */
import { Link } from 'react-router-dom';
import type { CSSProperties } from 'react';

const ITEMS: Array<[string, string]> = [
  ['Privacy', '/privacy'],
  ['Terms', '/terms'],
  ['Student Data Safeguards', '/student-data-safeguards'],
];

export function LegalFooterLinks({ style, newTab = true }: { style?: CSSProperties; newTab?: boolean }): JSX.Element {
  const extra = newTab ? { target: '_blank', rel: 'noopener noreferrer' } : {};
  return (
    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center', fontSize: 11.5, ...style }}>
      {ITEMS.map(([label, to], i) => (
        <span key={to} style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
          {i > 0 && <span style={{ color: 'var(--t4)' }}>·</span>}
          <Link to={to} {...extra} style={{ color: 'var(--t3)', textDecoration: 'none', fontWeight: 600 }}>{label}</Link>
        </span>
      ))}
    </div>
  );
}

export default LegalFooterLinks;
